import JassEnum from './enum';

/**
 * type playercolor
 */
export default class JassPlayerColor extends JassEnum {}
